import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="file-field"
export default class extends Controller {
  static targets = ["fileField"];

  simulateFileFieldClick() {
    this.fileFieldTarget.click();
  }
}
